import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ICoreState } from './state';

export const selectCoreState = createFeatureSelector<ICoreState>('core');

export const selectTenantSlug = createSelector(selectCoreState, (state) => state.tenantSlug);

export const selectAdministradora = createSelector(selectCoreState, (state) => state.administradora);
export const selectAdministradoraLoaded = createSelector(
  selectCoreState,
  (state) => state.administradoraLoaded
);
export const selectAdministradoraError = createSelector(
  selectCoreState,
  (state) => state.administradoraError
);

export const selectUser = createSelector(selectCoreState, (state) => state.user);
export const selectToken = createSelector(selectCoreState, (state) => state.token);
export const selectIsLogged = createSelector(selectUser, (user) => !!user);
export const selectIdentificarError = createSelector(
  selectCoreState,
  (state) => state.identificarError
);
export const selectLoginEtapa = createSelector(selectCoreState, (state) => state.loginEtapa);
export const selectLoginError = createSelector(selectCoreState, (state) => state.loginError);
export const selectIdentificacaoRequest = createSelector(
  selectCoreState,
  (state) => state.identificacaoRequest
);
export const selectICodSegurado = createSelector(selectCoreState, (state) => state.iCodSegurado);
export const selectTokenSessaoLogin = createSelector(
  selectCoreState,
  (state) => state.tokenSessaoLogin
);

export const selectSidenavOpened = createSelector(
  selectCoreState,
  (state) => state.sidenavOpened
);
